export const ADDRESSES_DOMAIN = 'app/modules/Contents/ADDRESSES_DOMAIN';
export const REQUEST_ADDRESS_TYPES = 'app/modules/Contents/REQUEST_ADDRESS_TYPES';
export const REQUEST_ADDRESS = 'app/modules/Contents/REQUEST_ADDRESS';
export const REQUEST_ADDRESSES_BY_IDS = 'app/modules/Contents/REQUEST_ADDRESSES_BY_IDS';

export const IDW_ADDRESSES = [
  { id: 'zwolle', name: 'In De Wal Zwolle', addressLine1: 'Kleefstraat', city: 'Zwolle', country: { name: 'Netherlands' } },
  {
    id: 'idwgermany',
    name: 'In De Wal Duitsland GmbH',
    addressLine1: 'Limburger Tor 114-117',
    city: 'Weeze',
    postcode: '47652',
    country: { name: 'Germany' },
  },
];
